module.exports = __webpack_public_path__ + "assets/images/nav-settings.75ef52bb0ff943a5118f2188bd27b592.svg";